<template>
  <AppSidebar />
  <div
    class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent"
  >
    <AppHeader />
    <div class="body flex-grow-1">
      <router-view />
    </div>
  </div>
</template>
<script>
import AppHeader from '@/components/App/Header.vue'

export default {
  name: 'AppLayout',
  components: {
    AppHeader,
  },
  data() {
    return {
      message: localStorage.getItem('message'),
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    },
  },
}
</script>
